import { useTranslation } from 'react-i18next';
import type { CatalogContentBundle } from '@/types/catalog.ts';
import { TextField, BriefingField } from './BaseFields.tsx';

interface SimpleBriefingFormProps {
  value: CatalogContentBundle;
  onChange: (next: CatalogContentBundle) => void;
  mode: 'create' | 'update';
  slugEditable?: boolean;
  briefingRequired?: boolean;
}

export default function SimpleBriefingForm({
  value,
  onChange,
  mode,
  slugEditable = true,
  briefingRequired = false,
}: SimpleBriefingFormProps) {
  const { t } = useTranslation();
  const slugReadOnly = mode === 'update' || !slugEditable;
  return (
    <div className="space-y-4">
      <TextField
        label={t('superuser.catalog.form.slug', { defaultValue: 'Slug' })}
        value={value.slug ?? ''}
        onChange={(v) => onChange({ ...value, slug: v })}
        readOnly={slugReadOnly}
        required={!slugReadOnly}
        pattern="^[a-z0-9-]+$"
        hint={!slugReadOnly ? 'lowercase + guiones' : undefined}
      />
      <TextField
        label={t('superuser.catalog.form.label', { defaultValue: 'Etiqueta' })}
        value={value.label}
        onChange={(v) => onChange({ ...value, label: v })}
        required
      />
      <BriefingField
        value={value.briefing ?? ''}
        onChange={(v) => onChange({ ...value, briefing: v })}
        required={briefingRequired}
      />
    </div>
  );
}
